import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { Button, FoodsIcon } from "@foodpilot/foods";
import { useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
import { CREATE, PRODUCT } from "src/context/FoodpilotContext.tsx";
import { URLHandler } from "src/services/URLHandler";

export const ProductPopover = () => {
    const { t } = useTranslation();
    const { canUser, selectedCompany } = useFoodpilotContext();
    const navigate = useNavigate();
    const location = useLocation();

    // Action directe pour créer un produit
    const handleCreateProduct = () => {
        if (selectedCompany === null) return;
        const currentUrl = location.pathname + location.search;
        const createUrl = URLHandler.product.create(selectedCompany.id, 0);
        navigate(`${createUrl}?returnUrl=${encodeURIComponent(currentUrl)}`);
    };

    return (
        <>
            {canUser(CREATE, PRODUCT) && (
                <Button
                    variant="primary"
                    id="create-product-button"
                    onClick={handleCreateProduct}
                    startIcon={<FoodsIcon size={2} icon="plus" />}
                >
                    {t("creer_un_produit")}
                </Button>
            )}
        </>
    );
};
